import React from "react";

import NoDataMessage from "../../common/NoDataMessage";
import { PlatformTeamUserRow } from "../../common/platformTypes";
import { BoolCheck } from "../BoolCheck";
import { PlatformUserLink, TeamLink } from "../DocumentLink";
import { DocumentTable, DocumentTableProperty } from "../DocumentTable";

type PlatformUsersTableProps = {
  /** One row per membership — a user in three teams appears three times. */
  rows: PlatformTeamUserRow[];
};

export const PlatformUsersTable: React.FunctionComponent<
  PlatformUsersTableProps
> = ({ rows }) => {
  const properties: DocumentTableProperty<PlatformTeamUserRow>[] = [
    {
      title: "Id",
      // Scoped by team: the same user id renders once per membership, and
      // DocumentLink builds its tooltip target from the id alone.
      render: (d) => (
        <PlatformUserLink docId={d.userId} scope={d.teamId}>
          <span className="text-monospace">{d.userId}</span>
        </PlatformUserLink>
      ),
      style: { maxWidth: "28%" },
    },
    {
      title: "Email",
      render: (d) => d.email ?? <span className="text-muted">—</span>,
    },
    { title: "Name", render: (d) => d.name },
    {
      title: "Team",
      render: (d) => <TeamLink docId={d.teamId}>{d.teamName}</TeamLink>,
    },
    {
      title: "Role",
      render: (d) => <span className="text-capitalize">{d.role}</span>,
    },
    {
      title: "Active Sub",
      render: (d) => <BoolCheck check={d.hasActiveSubscription} />,
    },
  ];

  if (!rows.length) {
    return <NoDataMessage componentName="platform user" />;
  }

  return (
    <DocumentTable<PlatformTeamUserRow>
      objects={rows}
      properties={properties}
    />
  );
};
